import PropTypes from 'prop-types';
import React from 'react';

const PhotoIcon = ({ color }) => (
  <svg width="30" height="25" viewBox="0 0 30 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M1.02292 0.842402L0 1.68446V12.3529V23.0214L1.02292 23.8635L2.04542 24.7059H15H27.9546L28.9771 23.8635L30 23.0214V12.3529V1.68446L28.9771 0.842402L27.9546 0H15H2.04542L1.02292 0.842402ZM22.8908 16.5464C24.7383 18.5699 26.25 20.3069 26.25 20.4067C26.25 20.5066 21.1875 20.5882 15 20.5882C8.8125 20.5882 3.75 20.5069 3.75 20.4077C3.75 20.1339 8.76667 14.9409 9.14 14.8283C9.31875 14.7745 10.2883 15.5777 11.295 16.6137C12.3017 17.6493 13.2187 18.4992 13.3333 18.5023C13.4479 18.505 14.7562 17.1987 16.2412 15.5994C17.7258 13.9997 19.0733 12.7307 19.2362 12.7795C19.3987 12.8278 21.0433 14.5229 22.8908 16.5464Z" fill={color} />
  </svg>

);

PhotoIcon.propTypes = {
  color: PropTypes.string.isRequired,
};

export default PhotoIcon;
